import { render, staticRenderFns } from "./PaymentInsuranceAccounts.vue?vue&type=template&id=74844983&"
import script from "./PaymentInsuranceAccounts.vue?vue&type=script&lang=js&"
export * from "./PaymentInsuranceAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports